import { FormControl, TextField, RadioGroup, FormControlLabel, Radio, Checkbox, InputLabel, MenuItem, FormGroup, Box, Modal, Theme, useTheme, OutlinedInput } from "@material-ui/core";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import JSZip from "jszip";
import { MdOutlineDescription } from "react-icons/md";
import BreadcrumbsDashboard from "../../../../components/BreadcrumbsDashboard";
import { Container, ButtonAlt, ButtonArticle, ButtonGroup, IconWrapper, BoldP, ImageWrapper, ButtonAdd } from "./styles";
import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import useWindowDimensions from "../../../../utils/useWindowDimensions";
import { useDashboard } from "../../../../context/DashboardContext";
import Button from "../../../../components/Button";
import ImageUploading, { ImageListType } from 'react-images-uploading';
import useArchive from "../../../../hooks/useArchive";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../../components/Toast";
import { BiBell } from "react-icons/bi"
import { BsCheck2Circle } from "react-icons/bs"
import useEditArchive from "../../../../hooks/useEditArchive";
import api from "../../../../services/api";
import { CategoriesProps, Enterprise } from "../../../../utils/types/RealtorTypes";
import { AiOutlinePlus } from "react-icons/ai"
import { getUrlAwsS3Realtor } from "../../../../utils/aws";
import { TextArea } from "../../../../components/Description";
import Eye from "../../../../icons/Eye";
import useClientAnnouncement from "../../../../hooks/useClientAnnouncement";
import useEditClientAnnouncement from "../../../../hooks/useEditClientAnnouncement";
import {GrClose} from "react-icons/gr"


function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
interface FormDataNew {
  id?: number;
  title: string;
  
  description: string;
  files: File[];
  cod_enteprise: number;

}
interface Announcement {
  id: number;
  title: string;
  description: string;
  hasBuilding:string;
  personName: number[];
  image: any; 
  files: File[];
}
const ClientAnnouncement = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { selectedData, isEdit, fetchCategories, fetchEnterprises, setIsGeneral, setTypeList, setBreadCrumbsName, setIsEditInside, setIsSavedAnnouncement } = useDashboard()
  const crumbs = [
    { name: 'MARKETING', url: '/marketing' },
    { name: isEdit ? 'Editar comunicado' : 'Adicionar novo comunicado', url: '/marketing/manage-content/client-announcement' }
  ]
  const { width } = useWindowDimensions();

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width && width < 540 ? '300px' : '540px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    textAlign: 'center'
  };

  const [enterprises, setEnterprises] = useState([] as Enterprise[])
  const [selectedEnterprise, setSelectedEnterprise] = useState<{ cod_enterprise: number, enterprise_code?: number, name_enterprise: string, enterprise_name?: string }>(!Array.isArray(selectedData.enterprise) && selectedData.enterprise || {} as { cod_enterprise: number, name_enterprise: string, enterprise_code?: number, enterprise_name?: string })
  const [imageEdit, setImageEdit] = useState(isEdit ? selectedData.thumbnail_url : '');
  const [imageEditNew, setImageEditNew] = useState({} as ImageListType)
  const [fileEdit, setFileEdit] = useState(isEdit ? selectedData.file_url : '')
  const [urlThumbNail, setUrlThumbNail] = useState<string>('');
  const [hasBuilding, setHasBuilding] = useState(isEdit ? selectedData.enterprise !== null ? 'sim' : 'nao' : '')
  const [title, setTitle] = useState<string>(isEdit ? selectedData.title ? selectedData.title : '' : '');
  const [images, setImages] = useState([] as ImageListType);
  const [description, setDescription] = useState<string>(isEdit ? selectedData.description ? selectedData.description : '' : '');
  const [descriptionEdit, setDescriptionEdit] = useState<string | undefined>(undefined);
  const [selectedFile, setSelectedFile] = useState<File>({} as File);
  const [isFilePicked, setIsFilePicked] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isEditModal, setIsEditModal] = useState<boolean>(false);
  const [isDeleteModal, setIsDeleteModal] = useState<boolean>(false);
  const [isOpenConfirmation, setIsOpenConfirmation] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isValidTitle, setIsValidTitle] = useState<boolean>(true)
  const [isValidDescription, setIsValidDescription] = useState<boolean>(true)
  const [isValidRelated, setIsValidRelated] = useState<boolean>(true)
  const [isValidFile, setIsValidFile] = useState<boolean>(true)
  const [isAnnouncementBoxVisible, setIsAnnouncementBoxVisible] = useState<boolean>(false)

  const [validationToast, setValidationToast] = useState<boolean>(false)
  const [isValidImage, setIsValidImage] = useState<boolean>(true)
  const [draftToast, setDraftToast] = useState<boolean>(false)
  const [toastNotification, setToastNotification] = useState(false);
  const [saveToast, setSaveToast] = useState<boolean>(false)
  const [disabledButtons, setDisabledButtons] = useState<boolean>(false);
  const [personName, setPersonName] =  useState<number[]>([])
  const [files, setFiles] = useState<File[]>([]);
  const [form, setForm] = useState([]);
  const [forms, setForms] = useState<Announcement[]>([]);
  const [formResetCounter, setFormResetCounter] = useState(0);
  const [selectedFormId, setSelectedFormId] = useState<number | null>(null);

  const handleSaveAndAddAnother = () => {
    if (title && description && images.length > 0 && files.length > 0 && hasBuilding.length > 0 && images.length) {
      const newAnnouncement = {
        id: Date.now(),
        title,
        description,
        hasBuilding,
        personName,
        image: images[0],
        files,
      };
      setForms([...forms, newAnnouncement]);
      setTitle('');
      setDescription('');
      setDescriptionEdit(undefined);
      setFormResetCounter(prev => prev + 1);
      setHasBuilding('');
      setPersonName([]);
      setImages([]);
      setFiles([]);
      setIsAnnouncementBoxVisible(true);
      setIsSavedAnnouncement(true);
    }

  };

  const handleEditAnnouncement = (id: number) => {
    
    setIsEditModal(false)
    const announcementToEdit = forms.find((form) => form.id === id);
    
    if (announcementToEdit) {
      setTitle(announcementToEdit.title);
      setDescription(announcementToEdit.description);
      setDescriptionEdit(announcementToEdit.description);
      setImages([announcementToEdit.image]);
      setFiles(announcementToEdit.files);
      setIsFilePicked(true);
      setHasBuilding(announcementToEdit.hasBuilding)
      setPersonName(announcementToEdit.personName)
      setForms(forms.filter((form) => form.id !== id));  
    }

  };

  const handleDeleteAnnouncement = (id: number) => {
    setForms(forms.filter((form) => form.id !== id));
    setIsDeleteModal(false);
    if (forms.length === 1) {
      setIsAnnouncementBoxVisible(false);
    }
  };

  const maxNumber = 1;
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const newFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      setIsFilePicked(true);

    }
    event.target.value = '';
  };
  const handleRemoveFile = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
   
  };

  useEffect(() => {
    if(files.length === 0){
      setIsFilePicked(false)
    }
  }, [files])
  
 

  const handleChangeBuilding = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHasBuilding(event.target.value)
  };
  const onChange = (imageList: ImageListType) => {
    setImages(imageList as never[]);
  };


  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      typeof value === 'string' 
        ? value.split(',').map(Number)
        : value.map(Number) 
    );
  };

  const handleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value)
  }
  const handleDescription = (value: string) => { 
    setDescription(value)
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsDelete(false);
  };
  const handleModalConfirmation = () => {
    setIsEditModal(true)
  };

  const handleEdit = () => {
    setIsEditModal(true)
  }

  const handleDelete = async () => {
    setIsDelete(true);
    try {
      await api.delete(`/enterprise/announcement/${selectedData.id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      setTimeout(function () {
        navigate('/marketing/list-data');
      }, 2500);
    } catch {
      return false
    }
  }
  useEffect(() => {
    if (!isValidRelated && hasBuilding.trim().length > 0) {
      setIsValidRelated(true);
    } else if (!isValidRelated && hasBuilding.trim().length === 0) {
      setIsValidRelated(false);
    }
    if (!isValidTitle && title.trim().length > 0) {
      setIsValidTitle(true);
    } else if (!isValidTitle && title.trim().length === 0) {
      setIsValidTitle(false);
    }
    if (!isValidImage && (images.length > 0 || imageEdit)) {
      setIsValidImage(true);
    } else if (!isValidImage && (images.length === 0 || !imageEdit)) {
      setIsValidImage(false);
    }
    if (!isValidFile && (isFilePicked || fileEdit)) {
      setIsValidFile(true);
    } else if (!isValidFile && (isFilePicked || !fileEdit)) {
      setIsValidFile(false);
    }
  }, [ isValidRelated, hasBuilding, isValidTitle, title, images, imageEdit, isValidImage, isValidFile, isFilePicked, fileEdit])
  useEffect(() => {
    fetchEnterprises().then((data) => { setEnterprises(data) })
  }, [])
  const setSrcImage = async () => {
    const url = await getUrlAwsS3Realtor(selectedData.thumbnail_url ?? '', selectedData.thumbnail_name ?? '', selectedData.is_public);
    setUrlThumbNail(url);
  }
  useEffect(() => {
    setSrcImage()
  }, [])
 
  const onSubmitForm = async (event: React.FormEvent, typeSubmit: string) => {
    event.preventDefault();
    let isValidForm = true;

    if (title.trim().length === 0) {
      setIsValidTitle(false);
      isValidForm = false;
    } else {
      setIsValidTitle(true);
    }

    if (description.trim().length === 0) {
      setIsValidDescription(false);
      isValidForm = false;
    } else {
      setIsValidDescription(true);
    }

    if (hasBuilding.trim().length === 0) {
      setIsValidRelated(false);
      isValidForm = false;
    } else {
      setIsValidRelated(true);
    }


    if (isEdit) {
      if (imageEdit || images) {
        setIsValidImage(true);
      } else {
        setIsValidImage(false)
        isValidForm = false;
      }

      if (isFilePicked || fileEdit) {
        setIsValidFile(true);
      } else {
        setIsValidFile(false);
        isValidForm = false;
      }
    } else {
      if (!isFilePicked) {
        setIsValidFile(false);
        isValidForm = false;
      } else {
        setIsValidFile(true);
      }

    }
    if (isValidForm) {
      if (typeSubmit === 'saveAndAdd') {
        // setForm((prev) => ({ ...prev, 'id': Date.now(), 'title': title, 'description': description, 'files': files, 'cod_enteprise': personName }));
        handleSaveAndAddAnother()
        setIsAnnouncementBoxVisible(true)
      } else {
      setDisabledButtons(true)
      if (typeSubmit === 'saveDraft' || typeSubmit === 'publish') {
        const newForm = {
          id: Date.now(),
          title: title,
          description: description,
          hasBuilding: hasBuilding,
          personName: personName,
          image: images[0]?.file,
          files: files,
        };
        
        const updatedForms = [...forms, newForm];
        setForms(updatedForms);
        
        try {
          // Criar um array de promises para processar cada formulario
          const formPromises = updatedForms.map(async (form) => {
            const zip = new JSZip();
            
            // Adiciona os arquivos ao ZIP
            Array.from(form.files).forEach((file) => {
              zip.file(file.name, file);
            });
            
            // Gera o ZIP como Blob
            const zipBlob = await zip.generateAsync({ type: "blob" });

            // eslint-disable-next-line react-hooks/rules-of-hooks
            return useClientAnnouncement({
              file: zipBlob,
              thumbnail: form.image.file ? form.image.file : form.image,
              title: form.title,
              description: form.description,
              cod_enterprise: form.personName,
              type: "enterpriseAnnouncement",
              is_draft: typeSubmit === 'saveDraft' ? true : false,
            });
          });
      
          // Executa todas as requisições ao mesmo tempo
         Promise.all(formPromises).then(() => {
             setToastNotification(true);
              setValidationToast(true)
             
             setTimeout(() => {

              navigate("/marketing/list-data");
          }, 2500);
          })
      
          
          setIsGeneral(false)
          setBreadCrumbsName('COMUNICADOS POR EMPREENDIMENTO - CLIENTES')
          setTypeList('enterpriseAnnouncement')
         
        } catch (error) {
          console.error("Erro ao enviar formulários:", error);
          alert("Erro ao enviar formulários.");
        } finally {
          setDisabledButtons(false);
        }
      }
      else if (typeSubmit === 'saveEdit') {
       
        const zip = new JSZip();
            
            // Adiciona os arquivos ao ZIP
            Array.from(files).forEach((file) => {
              zip.file(file.name, file);
            });
            
            // Gera o ZIP como Blob
            const zipBlob = await zip.generateAsync({ type: "blob" });
       
        Promise.all([
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEditClientAnnouncement({
            id: selectedData.correlation_id,
            file: files.length > 0 ? zipBlob : selectedFile,
            thumbnail: images && images.length > 0 ? images[0].file : imageEdit,
            title: title,
            description: description,
            cod_enterprise: personName,
            type: 'enterpriseAnnouncement',
           
          })
        ])
          .then(() => {
            setToastNotification(true);
            setSaveToast(true)
            setTimeout(function () {
              navigate('/marketing/list-data');
            }, 2500);

          })
        if (hasBuilding === 'nao') {
          setIsGeneral(true)
          setBreadCrumbsName('COMUNICADOS GERAIS - CLIENTES')
        } else {
          setIsGeneral(false)
          setBreadCrumbsName('COMUNICADOS POR EMPREENDIMENTO - CLIENTES')
        }
        setTypeList('enterpriseAnnouncement')
      }
      else if (typeSubmit === 'publishEdit') {
        Promise.all([
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEditClientAnnouncement({
            id: selectedData.correlation_id,
            file: selectedFile,
            thumbnail: images && images.length > 0 ? images[0].file : imageEdit,
            title: title,
            description: description,
            cod_enterprise: personName,
            type: 'enterpriseAnnouncement',
            is_draft: false,
          })
        ])
          .then(() => {
            setToastNotification(true);
            setValidationToast(true)
            setTimeout(function () {
              navigate('/marketing/list-data');
            }, 2500);

          })
        if (hasBuilding === 'nao') {
          setIsGeneral(true)
          setBreadCrumbsName('COMUNICADOS GERAIS - CLIENTES')
        } else {
          setIsGeneral(false)
          setBreadCrumbsName('COMUNICADOS POR EMPREENDIMENTO - CLIENTES')
        }
        setTypeList('enterpriseAnnouncement')
      }
    
      setSaveToast(false)
      setToastNotification(false);
      setValidationToast(false);
      setDraftToast(false);
    }
    }
  }
  return (
    <Container>
      {toastNotification &&
        <div id="toast-container2">
          <Toast Icon={validationToast || draftToast || saveToast ? BsCheck2Circle : BiBell} onClose={() => setToastNotification(!toastNotification)} status={validationToast || saveToast ? 'success' : draftToast ? 'draft' : ''} >
            <p>
              {validationToast && 'Seu comunicado foi publicado com sucesso'}
              {draftToast && 'Seu comunicado foi salvo como rascunho'}
              {saveToast && 'Seu comunicado foi salvo com sucesso'}

            </p>
          </Toast>
        </div>
      }
      <div>
        <BreadcrumbsDashboard crumbs={crumbs} />
      </div>
      <p className="title" style={{ fontSize: 20, textTransform: 'uppercase', color: '#000' }}>{isEdit ? 'Editar' : 'Adicionar novo'} Arquivo</p>
      <div className="div-banner">
        <div className="top-banner">
          <div className="esquerda">
            <p>Capa do comunicado</p>
            <p>A capa será mostrada no início do comunicado.</p>
            <p><b>Dimensões:</b> 1216x384px / <b>Área de Segurança:</b> 640x384px / <b>Tamanho máximo:</b> 1MB</p>
          </div>
        </div>
        <div className="banner-e-past">
          <div className="image">
            {imageEdit ?
              <ImageUploading
                acceptType={['jpg', 'jpeg', 'png']}
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
                maxFileSize={1000000}
              >
                {({
                  imageList,
                  onImageUpload,
                  onImageUpdate,
                  isDragging,
                  dragProps,
                  errors
                }) => (

                  <div className="upload__image-wrapper" {...dragProps} >


                    <ImageWrapper>


                      <>
                        <img className="" alt="edit" src={imageList[0] ? imageList[0]['data_url'] : urlThumbNail} />
                        <div className="image-item__btn-wrapper">

                          <button onClick={() => { onImageUpload(); setImageEditNew(imageList) }}>
                            <FiEdit width="48" height="48" />
                          </button>

                        </div>
                      </>

                    </ImageWrapper>

                    {errors?.maxFileSize && <span>A imagem é muito grande, tente subir um arquivo com no máximo 1 mb.</span>}
                  </div>
                )}
              </ImageUploading>
              :
              <ImageUploading
                acceptType={['jpg', 'jpeg', 'png']}
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
                maxFileSize={1000000}
              >
                {({
                  imageList,
                  onImageUpload,
                  onImageUpdate,
                  isDragging,
                  dragProps,
                  errors
                }) => (

                  <div className="upload__image-wrapper" {...dragProps} >

                    {images.length === 0 ?
                      <ButtonAdd onClick={onImageUpload}><AiOutlinePlus />ADICIONAR CAPA</ButtonAdd>

                      :
                      <ImageWrapper>

                        {imageList.map((image, index) => (
                          <>
                            <img key={index} className="" alt="add" src={image['data_url']} />
                            <div className="image-item__btn-wrapper">

                              <button onClick={() => onImageUpdate(index)}>
                                <FiEdit width="48" height="48" />
                              </button>

                            </div>
                          </>
                        ))}
                      </ImageWrapper>
                    }
                    {errors?.maxFileSize && <span>A imagem é muito grande, tente subir um arquivo com no máximo 1 mb.</span>}
                  </div>
                )}
              </ImageUploading>
            }

            </div>
            {isAnnouncementBoxVisible && 
            <div className="saved-announcements">
              <p className="title">COMUNICADOS SALVOS</p>
              <div>
                {forms.length > 0 && forms.map((form) => (
                <div key={form.id} className="announcement-item">
                  <p>{form.title}</p>
                  <div>
                    <span className="anch-action" onClick={() => {
                      setSelectedFormId(form.id);
                      setIsEditModal(true);
                    }}>
                      <Eye />
                    </span>
                    <span className="anch-action" onClick={() => {
                      setSelectedFormId(form.id);
                      setIsDeleteModal(true);
                    }}>
                      <GrClose className="icon" />
                    </span>
                  </div>
                </div>
                ))}
                <Modal open={isEditModal} onClose={() => setIsEditModal(false)}>
                  <Box sx={style}>
                    <div className="modalcontent">
                      <IconWrapper>
                        <MdOutlineDescription />
                      </IconWrapper>
                      <BoldP>Você irá perder todo o progresso do comunicado atual</BoldP>
                      <ButtonGroup>
                        <ButtonArticle
                          $primary
                          $modal
                          onClick={() => {
                            if (selectedFormId !== null) {
                              handleEditAnnouncement(selectedFormId);
                            }
                          }}
                        >
                          Confirmar
                        </ButtonArticle>
                        <ButtonArticle $modal onClick={() => setIsEditModal(false)}>Cancelar</ButtonArticle>
                      </ButtonGroup>
                    </div>
                  </Box>
                </Modal>
                        
                <Modal open={isDeleteModal} onClose={() => setIsDeleteModal(false)}>
                  <Box sx={style}>
                    <div className="modalcontent">
                      <IconWrapper>
                        <MdOutlineDescription />
                      </IconWrapper>
                      <BoldP>
                        Deseja mesmo apagar {forms.find((f) => f.id === selectedFormId)?.title}?
                      </BoldP>
                      <ButtonGroup>
                        <ButtonArticle
                          $primary
                          $modal
                          onClick={() => {
                            if (selectedFormId !== null) {
                              handleDeleteAnnouncement(selectedFormId);
                            }
                          }}
                        >
                          Confirmar
                        </ButtonArticle>
                        <ButtonArticle $modal onClick={() => setIsDeleteModal(false)}>Cancelar</ButtonArticle>
                      </ButtonGroup>
                    </div>
                  </Box>
                </Modal>

          </div>
        </div>
            }
            
        </div>
      </div>
      {!isValidImage && <p className="error">É obrigatório adicionar uma imagem para o banner</p>}
      <div className="form">
        <FormControl className="">
          <div className="form-inputs">
            <div className="form-title">
              <p className="title">Preencha as informações a seguir:</p>
              <TextField className="titlefield" id="outlined-size-small" label="Título do comunicado" variant="outlined" fullWidth value={title} onChange={handleTitle} inputProps={{ maxLength: 50 }} />
              {!isValidTitle && <p className="error">Campo obrigatório</p>}
              <TextArea key={formResetCounter} description={descriptionEdit} id="outlined-size-small" label="Descrição do comunicado" onChange={handleDescription} />
              {!isValidDescription && <p className="error">Campo Obrigatório</p>}
            </div>
            <div className="upload-box">
              <span className="title">Arquivo a ser compartilhado</span>
              <span className="upload-notice">Adicione um arquivo para ser compartilhado no Hm Estelar.</span>
              <span className="upload-notice">Extensões aceitas: .pdf, .ppt, .doc, .xlsx, .png, .jpeg, .mpeg, .mp4, .avi, .zip</span>
            </div>
            {fileEdit?.length ?
            <div>
              {!isFilePicked ?
                <div className="attachedfile">
                  {selectedData.file_name}
                  <label className="label2" htmlFor="file"><FiEdit /></label>
                  <input id="file" type="file" name="file" accept=".zip, .pdf, .ppt, .pptx, .doc, .docx, .xml, .xlsx, .xls, .png, .jpeg, .mpg, .mp4, .avi, .jpg" style={{ visibility: "hidden" }} onChange={handleFileChange} />
                </div>
                :
                <div className="attachedfile">
                  {selectedFile.name}
                  <label className="label2" htmlFor="file"><FiEdit /></label>
                  <input id="file" type="file" name="file" accept=".zip, .pdf, .ppt, .pptx, .doc, .docx, .xml, .xlsx, .xls, .png, .jpeg, .mpg, .mp4, .avi, .jpg" style={{ visibility: "hidden" }} onChange={handleFileChange} />
                </div>
              }
            </div>
            :
            <div className="attach-button">
              {!isFilePicked  ?
                <div className="pdfinput">
                  <div className="pdfbutton">
                    <FiEdit></FiEdit>
                    <label className="label1" htmlFor="file"> Anexar Arquivo</label>
                  </div>
                  <input id="file" type="file" name="file" accept=".zip, .pdf, .ppt, .pptx, .doc, .docx, .xml, .xlsx, .xls, .png, .jpeg, .mpg, .mp4, .avi, .jpg" style={{ visibility: "hidden" }} onChange={handleFileChange} multiple/>
                </div>
                :
                <div className="attachedfile">
                  {files.map((file, index) => (
                    <div key={index} className="attachedbutton">
                    <label className="label2" htmlFor="file"><FiEdit /></label>
                      {file.name}
                    <label onClick={() => handleRemoveFile(index)} className="label2" htmlFor="file">X</label>
                    </div>
                  
                  ))}
                  
                  <input id="file" type="file" name="file" accept=".zip, .pdf, .ppt, .pptx, .doc, .docx, .xml, .xlsx, .xls, .png, .jpeg, .mpg, .mp4, .avi, .jpg" style={{ visibility: "hidden" }} onChange={handleFileChange} multiple/>
                  
                </div>
              }
            </div>
            }
            {!isValidFile && <p className="error error-input">É obrigatório anexar um arquivo</p>}
            {!isEdit &&
                        <div className="link-enterprise">
                        <p className="title">Esse comunicado é relacionado a um ou mais empreendimentos específicos?</p>
                        <FormControl required>
                          <RadioGroup>
                            <FormControlLabel value="yes" control={<Radio value='sim' onChange={handleChangeBuilding} checked={hasBuilding === 'sim'} />} label="Sim" />
                            {hasBuilding === 'sim' &&
                              <div className="select-enterprise">
                                <FormControl variant="outlined" fullWidth>
                                  <InputLabel id="demo-multiple-name-label">{isEdit ? selectedEnterprise.enterprise_name : 'Selecione o empreendimento'}</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    multiple
                                    value={personName}
                                    onChange={handleChange}
                                    input={<OutlinedInput label="Selecione o empreendimento" />}
          
                                    fullWidth
                                  >
                                    {enterprises.map(enterprise => (
                                      <MenuItem key={enterprise.cod_enterprise} value={enterprise.cod_enterprise} >{enterprise.name_enterprise}</MenuItem>
                                    ))}
          
                                  </Select>
                                </FormControl>
                              </div>
                            }
                            <FormControlLabel value="no" control={<Radio value='nao' onChange={handleChangeBuilding} checked={hasBuilding === 'nao'} />} label="Não (O comunicado será enviado para todos os empreendimentos)" />
                          </RadioGroup>
                        </FormControl>
                      </div>
            }

            {!isValidRelated && <p className="error">Campo obrigatório</p>}


          </div>
        
        </FormControl>
      </div>
      <div className="buttons">
        {!isEdit ?
          <>
            <ButtonAlt $primary onClick={(event) => onSubmitForm(event, "publish")} disabled={disabledButtons}>Publicar</ButtonAlt>
            <ButtonAlt $modal onClick={(event) => onSubmitForm(event, "saveAndAdd")} disabled={disabledButtons}>Salvar e adicionar outro</ButtonAlt>
            <ButtonAlt $secondary onClick={(event) => onSubmitForm(event, "saveDraft")} disabled={disabledButtons}>Salvar como rascunho</ButtonAlt>

          </>
          :
          <>
            <ButtonAlt $primary onClick={(event) => onSubmitForm(event, "saveEdit")} disabled={disabledButtons}>Salvar Alteraçoes</ButtonAlt>
            {selectedData.is_draft &&
              <ButtonAlt $primary onClick={(event) => onSubmitForm(event, "publishEdit")} disabled={disabledButtons}>Salvar e Publicar</ButtonAlt>
            }
            <ButtonAlt $modal onClick={handleOpen}>Arquivar</ButtonAlt>
          </>
        }
      </div>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          {!isDelete ?
            <div className="modalcontent">
              <IconWrapper>
                <MdOutlineDescription />
              </IconWrapper>
              <BoldP>Tem certeza de que deseja arquivar este arquivo?</BoldP>
              <ButtonGroup>
                <ButtonArticle $primary $modal onClick={handleDelete}>Arquivar</ButtonArticle>
                <ButtonArticle $modal onClick={handleClose}>Cancelar</ButtonArticle>
              </ButtonGroup>
            </div>
            :
            <div>
              <IconWrapper>
                <MdOutlineDescription />
              </IconWrapper>
              <BoldP>O arquivo foi arquivado com sucesso.</BoldP>
              <ButtonArticle $confirmation onClick={handleClose}>Voltar</ButtonArticle>
            </div>
          }

        </Box>
      </Modal>

    </Container>
  )
}
export default ClientAnnouncement